import { getClientByUrl } from "./getClientByUrl";

export default {
  BASE_API_URL: "https://fni-api-np.dealertrack.com/sfni/uat1/payoff-quotes/v2",
  CAPTCHA_SITE_KEY: "6LeHaMEUAAAAACOqdxc9kFk2PmEfPQ1_ntESh7LE",
  LENDER_ID: "AHC",
  DEALER_DTC_ID: 330415,
  PQ_URL: "https://ww2.uat.dealertrack.app.coxautoinc.com/payoff/",
  CLIENT: getClientByUrl({
    local: {
      HOST_NAME: "http://localhost:3000"
    },
    np: {
      HOST_NAME:
        "https://fni-static-np.dealertrack.com/apps/fni-payoff-quote-app/versions/1.0.0/index.html"
    },
    prod: {
      HOST_NAME: "prod not supported here, this is just placeholder"
    }
  })
};
